/**
 * `[ -1, -1, 1, -1, -1, 1, 1, 1 ]`
 */
export const TRIANGLE_STRIP_QUAD = [-1, -1, 1, -1, -1, 1, 1, 1];

/**
 * `[ -1, -1, 0, 1, -1, 0, -1, 1, 0, 1, 1, 0 ]`
 */
export const TRIANGLE_STRIP_QUAD_3D = [-1, -1, 0, 1, -1, 0, -1, 1, 0, 1, 1, 0];

/**
 * `[ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1 ]`
 */
export const TRIANGLE_STRIP_QUAD_NORMAL = [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1];

/**
 * `[ 0, 0, 1, 0, 0, 1, 1, 1 ]`
 */
export const TRIANGLE_STRIP_QUAD_UV = [0, 0, 1, 0, 0, 1, 1, 1];
